module.exports = __webpack_public_path__ + "img/login.70398f37.png";